// IE11 needs polyfill for certain features - for..of, Symbol, etc
import "babel-polyfill";
